import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

export default function OwnerAdminLogin({ onLogin }) {
  const [secret, setSecret] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/owner/auth`, { secret });
      localStorage.setItem('hrtrack_admin_token', res.data.token);
      onLogin();
    } catch {
      setError('Invalid secret. Access denied.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent' }}>
      <div style={{ background: 'var(--glass-2)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 16, padding: '40px 36px', width: 360, boxShadow: '0 20px 60px rgba(0,0,0,.4)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: '1.8rem', fontWeight: 800, color: 'var(--text)' }}>HR<span style={{ color: '#4f46e5' }}>Track</span></div>
          <div style={{ color: 'var(--muted)', marginTop: 6, fontSize: '0.85rem' }}>Owner Admin Access</div>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, marginBottom: 6, color: 'var(--text-2)' }}>Secret Key</label>
            <input
              type="password"
              value={secret}
              onChange={e => setSecret(e.target.value)}
              placeholder="Enter owner secret"
              autoFocus
              required
              style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--glass-border)', borderRadius: 8, fontSize: '0.9rem', boxSizing: 'border-box' }}
            />
          </div>
          {error && <div style={{ background: '#fee2e2', color: '#991b1b', padding: '8px 12px', borderRadius: 8, marginBottom: 14, fontSize: '0.875rem' }}>{error}</div>}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '10px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer' }}>
            {loading ? 'Verifying…' : 'Access Admin Panel'}
          </button>
        </form>
      </div>
    </div>
  );
}
